import { useGetFormalOffers } from '../../../api/lending/lapiHooks';

export const useGetValidFormalOffer = () => {
  const { formalOffers, loadingFormalOffers } = useGetFormalOffers();
  const formalOfferProductType = formalOffers?.formal_offers?.[0]?.product_type;
  const formalOfferIsValid =
    formalOffers?.formal_offers?.[0]?.is_valid === true;

  const hasValidIwocapayFormalOffer =
    formalOfferProductType === 'iwocapay' && formalOfferIsValid;

  return {
    formalOffer: hasValidIwocapayFormalOffer
      ? formalOffers?.formal_offers?.[0]
      : undefined,
    loading: loadingFormalOffers,
  };
};
